export default __webpack_public_path__ + "static/media/faqicon8.dc3eec29.svg";